import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from "react";
import { useTransition, animated } from "react-spring";
import ReachAlert from "@reach/alert";
import Alert from "./Alert";
import { useTimeout } from "./useTimeout";
var getStyle = function getStyle(position) {
  var style = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  };
  if (position.includes("right")) {
    style.alignItems = "flex-end";
  } else if (position.includes("left")) {
    style.alignItems = "flex-start";
  }
  return style;
};
export var Message = function Message(_ref) {
  var id = _ref.id,
    message = _ref.message,
    position = _ref.position,
    onRequestRemove = _ref.onRequestRemove,
    _ref$requestClose = _ref.requestClose,
    requestClose = _ref$requestClose === void 0 ? false : _ref$requestClose,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 30000 : _ref$duration;
  var container = React.useRef(null);
  var _React$useState = React.useState(duration),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    timeout = _React$useState2[0],
    setTimeout = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    localShow = _React$useState4[0],
    setLocalShow = _React$useState4[1];
  var isFromTop = position === "top-left" || position === "top-right" || position === "top";
  useTimeout(close, timeout);
  var animation = {
    config: {
      mass: 1,
      tension: 185,
      friction: 26
    },
    from: {
      opacity: 1,
      height: 0,
      transform: "translateY(".concat(isFromTop ? "-100%" : 0, ") scale(1)")
    },
    enter: function enter() {
      return function (next) {
        return next({
          opacity: 1,
          height: container.current.getBoundingClientRect().height,
          transform: "translateY(0) scale(1)"
        });
      };
    },
    leave: {
      opacity: 0,
      height: 0,
      transform: "translateY(0 scale(0.9)"
    },
    onRest: onRest
  };
  var transition = useTransition(localShow, null, animation);
  var style = React.useMemo(function () {
    return getStyle(position);
  }, [position]);
  function onMouseEnter() {
    setTimeout(null);
  }
  function onMouseLeave() {
    setTimeout(duration);
  }
  function onRest() {
    if (!localShow) {
      onRequestRemove();
    }
  }
  function close() {
    setLocalShow(false);
  }
  React.useEffect(function () {
    if (requestClose) {
      setLocalShow(false);
    }
  }, [requestClose]);
  function renderMessage() {
    if (typeof message === "string" || React.isValidElement(message)) {
      return React.createElement(Alert, {
        id: id,
        title: message,
        onClose: close
      });
    }
    if (typeof message === "function") {
      return message({
        id: id,
        onClose: close
      });
    }
    return null;
  }
  return React.createElement(React.Fragment, null, transition.map(function (_ref2) {
    var key = _ref2.key,
      item = _ref2.item,
      props = _ref2.props;
    return item && React.createElement(animated.div, {
      key: key,
      className: "Toaster__message",
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: Object.assign({
        opacity: props.opacity,
        height: props.height
      }, style)
    }, React.createElement(animated.div, {
      style: {
        transform: props.transform,
        pointerEvents: "auto"
      },
      ref: container,
      className: "Toaster__message-wrapper"
    }, React.createElement(ReachAlert, null, renderMessage())));
  }));
};